import { useCallback, useEffect, useState } from 'react'
import { api, type Overview as OverviewData } from '../adminApi'
import { fmtBytes, fmtAgoUnix } from '../format'

function Stat({ label, value, sub, color }: { label: string; value: React.ReactNode; sub?: string; color?: string }) {
  return (
    <div className="card panel" style={{ padding: '16px 18px' }}>
      <div className="muted" style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: '.04em' }}>{label}</div>
      <div style={{ fontSize: 28, fontWeight: 700, lineHeight: 1.1, margin: '6px 0 2px', color: color || 'inherit' }}>{value}</div>
      {sub && <div className="muted" style={{ fontSize: 12 }}>{sub}</div>}
    </div>
  )
}

function ServerPill({ name, geo, up }: { name: string; geo: string; up: boolean }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', borderRadius: 10, border: '1px solid var(--line)' }}>
      <span style={{ width: 10, height: 10, borderRadius: 10, background: up ? 'var(--ok)' : 'var(--err)', flexShrink: 0 }} />
      <div>
        <div style={{ fontWeight: 600, fontSize: 14 }}>{name} <span className="muted" style={{ fontWeight: 400 }}>· {geo}</span></div>
        <div className="muted" style={{ fontSize: 12 }}>{up ? 'на связи' : 'недоступен'}</div>
      </div>
    </div>
  )
}

export function Overview() {
  const [d, setD] = useState<OverviewData | null>(null)
  const [err, setErr] = useState<string | null>(null)

  const load = useCallback(async () => {
    try { setD(await api.overview()); setErr(null) }
    catch { setErr('Не удалось загрузить обзор.') }
  }, [])

  useEffect(() => {
    load()
    const id = window.setInterval(load, 60000)
    return () => clearInterval(id)
  }, [load])

  if (err) return <div className="alert err">{err}</div>
  if (!d) return <div className="empty"><span className="spin" /></div>

  const nl = d.servers.failoverMode === '153'
  return (
    <>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: 12, marginBottom: 16 }}>
        <Stat label="Клиентов" value={d.clientsTotal} sub={`${d.active} активных`} />
        <Stat label="Онлайн сейчас" value={d.onlineNow} color={d.onlineNow > 0 ? 'var(--ok)' : undefined} />
        <Stat label="Истекают <7 дн" value={d.expiringSoon} color={d.expiringSoon > 0 ? 'var(--warn)' : undefined} />
        <Stat label="Трафик ↓" value={fmtBytes(d.trafficDown)} sub="скачано клиентами" />
        <Stat label="Трафик ↑" value={fmtBytes(d.trafficUp)} sub="отдано клиентами" />
      </div>

      <div className="card panel" style={{ marginBottom: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, gap: 8 }}>
          <h3 style={{ margin: 0 }}>Серверы</h3>
          <span style={{ fontSize: 12.5, color: nl ? 'var(--warn)' : 'var(--ok)', whiteSpace: 'nowrap' }}>
            {nl ? '⚠ активен запасной: Нидерланды' : '✓ основной: Германия'}
          </span>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 10 }}>
          <ServerPill name="Основной (81)" geo="Германия 🇩🇪" up={d.servers.de.up} />
          <ServerPill name="Запасной (153)" geo="Нидерланды 🇳🇱" up={d.servers.nl.up} />
        </div>
      </div>

      <div className="muted" style={{ fontSize: 12 }}>
        {!d.generatedAt
          ? 'сбор статистики запускается…'
          : (Date.now() / 1000 - d.generatedAt > 300
            ? <span style={{ color: 'var(--warn)' }}>⚠ данные устарели ({fmtAgoUnix(d.generatedAt)}) — сбор статистики не отвечает</span>
            : `данные обновлены ${fmtAgoUnix(d.generatedAt)}`)}
      </div>
    </>
  )
}
